<script setup lang="ts">
import { computed } from 'vue'
import InlineSvg from 'vue-inline-svg'
import { useStaticAsset } from '@/composables/useStaticAsset'

const TEMPLATE_COUNT = 4
const asset = useStaticAsset()

const props = withDefaults(
  defineProps<{
    index?: number
    src?: string
  }>(),
  {
    index: 0,
    src: ''
  }
)

const templateUrl = computed(() => {
  return asset(`img/main-page/people-image-${props.index % TEMPLATE_COUNT}.svg`)
})

function addImage(svg: SVGElement) {
  const randomId = Math.random().toString(36).slice(2)
  const index = props.index % TEMPLATE_COUNT
  const rect = svg.querySelector(`rect[fill="url(#pattern${index})"]`)
  const pattern = svg.querySelector(`pattern#pattern${index}`)

  if (!rect || !pattern) return svg

  rect.setAttribute('fill', `url(#${randomId})`)
  pattern.setAttribute('id', randomId)

  const img = svg.querySelector('image')
  if (img) img.setAttribute('xlink:href', props.src)
  return svg
}
</script>

<template>
  <InlineSvg ref="svg" :src="templateUrl" :transform-source="addImage" />
</template>
